import PropTypes from 'prop-types';

var propTypes = {
    elevation: PropTypes.number,
    onClick: PropTypes.func,
    className: PropTypes.string,
    'data-testid': PropTypes.string,
};
var defaultProps = {
    elevation: 2,
    'data-testid': 'spoton-card-component',
};

export { defaultProps, propTypes };
